document.addEventListener('alpine:init', () => {
    Alpine.store('ugc', {
      modalOpen: false,
      modalMobileOpen: false,
      currentVideo: 1,

      openModal(currentVideo) { 
        this.currentVideo = currentVideo;

        // Check if window size is mobile
        const isMobile = window.innerWidth <= 768;
        if (isMobile) {
          this.modalMobileOpen = true;
          this.modalOpen = false;
          window.dispatchEvent(new CustomEvent('ugc-modal-mobile-open', { detail: this.currentVideo, bubbles: true }));
        } else {
          this.modalMobileOpen = false;
          this.modalOpen = true;
          window.dispatchEvent(new CustomEvent('ugc-modal-open', { detail: this.currentVideo, bubbles: true }));
        }
        
      },
      closeModal() { 
        this.modalOpen = false; 
        this.modalMobileOpen = false;
        this.currentVideo = 1;
        window.dispatchEvent(new CustomEvent('ugc-modal-close', { bubbles: true }));
        window.dispatchEvent(new CustomEvent('ugc-modal-mobile-close', { bubbles: true }));
      }
    });

    Alpine.data('ugcModal', () => ({
      isPlaying: false,

      init() {
        const placeholders = new Map();
        const selectors = ['[data-oke-star-rating]', '.ugc-append', 'delm-widget'];

        window.addEventListener('ugc-modal-open', () => {
          const target = document.querySelector('.product-info-slot');

          selectors.forEach(selector => {
            document.querySelectorAll(selector).forEach(node => {
              console.log('Processing node for selector:', selector, node);
              if (!placeholders.has(node)) {
                // Drop a placeholder where the node originally was
                const placeholder = document.createComment(`placeholder for ${selector}`);
                node.parentNode.insertBefore(placeholder, node);
                placeholders.set(node, placeholder);
              }
              target.appendChild(node); // move into modal slot
            });
          });
        });

        window.addEventListener('ugc-modal-close', () => {
          placeholders.forEach((placeholder, node) => {
            if (placeholder.parentNode) {
              placeholder.parentNode.insertBefore(node, placeholder);
              placeholder.remove();
            }
          });
          placeholders.clear();

          const videoCount = document.querySelectorAll('[x-ref^="video"]').length;
          this.pauseAllVideos(videoCount);
        });

        window.addEventListener('rh-variant-changed', (event) => {
          // Only play video if modal is actually open
          if (this.$store.ugc.modalOpen) {
            this.playCurrentVideo();
          } else {
            // Make sure all videos are paused when variant changes while modal is closed
            const videoCount = document.querySelectorAll('[x-ref^="video"]').length;
            this.pauseAllVideos(videoCount);
          }
        });
      },

      pauseAllVideos(videoSize){
        for (let i = 1; i <= videoSize; i++) {
          const video = this.$refs['video' + i];
          if (video) {
            console.log('Pausing video', i, video.paused ? '(already paused)' : '(was playing)');
            video.pause();
            video.currentTime = 0; // Reset video to beginning
            // Reset button states
            const playBtn = this.$refs['playBtn' + i];
            const pauseBtn = this.$refs['pauseBtn' + i];
            if (playBtn) playBtn.style.display = 'block';
            if (pauseBtn) pauseBtn.style.display = 'none';
          } else {
            console.log('Video', i, 'not found in refs');
          }
        }
      },      
      
      playCurrentVideo() {
        const currentVideoIndex = this.$store.ugc.currentVideo;
        const video = this.$refs['video' + currentVideoIndex];
        if (video) {
          // Lazy load video if not already loaded
          this.lazyLoadVideo(video);
          
          video.play().catch(e => console.error('Error playing video:', e));
          // Update button states
          const playBtn = this.$refs['playBtn' + currentVideoIndex];
          const pauseBtn = this.$refs['pauseBtn' + currentVideoIndex];
          if (playBtn) playBtn.style.display = 'none';
          if (pauseBtn) pauseBtn.style.display = 'block';
        } 
      },

      lazyLoadVideo(videoElement) {
        // Check if video is already loaded
        if (videoElement.dataset.lazyLoaded === 'true') {
          return;
        }

        // Find template elements with video sources
        const templates = videoElement.querySelectorAll('.video-source-template');
        
        templates.forEach(template => {
          const source = document.createElement('source');
          source.src = template.dataset.src;
          source.type = template.dataset.type;
          videoElement.appendChild(source);
        });

        // Mark as loaded and reload video to recognize new sources
        videoElement.dataset.lazyLoaded = 'true';
        videoElement.load();
        
        console.log('Video sources loaded');
      },

      toggleMute(videoIndex) {
        const video = this.$refs['video' + videoIndex];
        if (video) {
          video.muted = !video.muted;
          
          // Update volume button states
          const volumeOnBtn = this.$refs['volumeOnBtn' + videoIndex];
          const volumeDownBtn = this.$refs['volumeDownBtn' + videoIndex];
          
          if (video.muted) {
            // Video is now muted - show volume down icon
            if (volumeOnBtn) volumeOnBtn.style.display = 'none';
            if (volumeDownBtn) volumeDownBtn.style.display = 'block';
          } else {
            // Video is now unmuted - show volume on icon
            if (volumeOnBtn) volumeOnBtn.style.display = 'block';
            if (volumeDownBtn) volumeDownBtn.style.display = 'none';
          }
        }
      },

      toggleVideoPlayPause(videoIndex) {
        const video = this.$refs['video' + videoIndex];
        if (video) {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        }
      },

      switchToVideo(videoIndex, videoSize) {
        // First pause all videos
        this.pauseAllVideos(videoSize);
        
        // Update the current video
        this.$store.ugc.currentVideo = videoIndex;
        
        console.log('Current video after switch:', this.$store.ugc.currentVideo);
        
        // Wait for Alpine to update the DOM, then play the new video
        this.$nextTick(() => {
          this.playCurrentVideo();
        });
      }
    }));

    Alpine.data('ugcModalMobile', () => ({
      splideInstance: null,
      currentMobileVideo: 1,
      isMuted: false, // Start unmuted for mobile (will be set to false on modal open)
      isPlaying: false,

      init() {
        console.log('UGC Mobile Modal initialized');

        const placeholders = new Map();
        const selectors = ['[data-oke-star-rating]', '.ugc-append', 'delm-widget'];

        window.addEventListener('ugc-modal-mobile-open', () => {
            document.body.classList.add('ugc-modal-mobile-open');
            document.documentElement.classList.add('ugc-modal-mobile-open');
          
          // Automatically unmute videos when modal opens
          this.isMuted = false;
          this.updateVolumeButtonState();
          console.log('Videos automatically unmuted on mobile modal open');
          
          this.initializeMobileSlider();
          this.currentMobileVideo = this.$store.ugc.currentVideo;
          
          // Navigate to current video and play it
          this.$nextTick(() => {
            console.log('Navigating to video and playing...', this.currentMobileVideo);
            if (this.splideInstance) {
              this.splideInstance.go(this.currentMobileVideo - 1);
              // Use force play to ensure autoplay on modal open
              setTimeout(() => {
                this.forcePlayMobileVideo(this.currentMobileVideo);
              }, 200);
            }
            
            // Ensure volume button state is correct after DOM update
            setTimeout(() => {
              this.updateVolumeButtonState();
            }, 100);
          });
        });

        window.addEventListener('ugc-modal-mobile-close', () => {
          document.body.classList.remove('ugc-modal-mobile-open');
          document.documentElement.classList.remove('ugc-modal-mobile-open');
          this.pauseAllMobileVideos();
          if (this.splideInstance) {
            this.splideInstance.destroy();
            this.splideInstance = null;
          }
          
          // Restore elements
          placeholders.forEach((placeholder, node) => {
            if (placeholder.parentNode) {
              placeholder.parentNode.insertBefore(node, placeholder);
              placeholder.remove();
            }
          });
          placeholders.clear();
        });

        window.addEventListener('rh-variant-changed', (event) => {
          // Only play video if mobile modal is actually open
          if (this.splideInstance && this.$store.ugc.modalMobileOpen) {
            this.playMobileVideo(this.currentMobileVideo);
          } else {
            // Make sure all videos are paused when variant changes while modal is closed
            this.pauseAllMobileVideos();
          }
        });
      },

      initializeMobileSlider() {
        console.log('Initializing mobile slider...');
        if (this.splideInstance) {
          this.splideInstance.destroy();
        }

        this.$nextTick(() => {
          console.log('Slider element:', this.$refs.mobileSlider);
          
          if (!this.$refs.mobileSlider) {
            console.error('Mobile slider element not found!');
            return;
          }

          // Check if Splide is available
          if (typeof Splide === 'undefined') {
            console.error('Splide library not loaded!');
            return;
          }

          this.splideInstance = new Splide(this.$refs.mobileSlider, {
            direction: 'ttb',
            height: '100vh',
            wheel: true,
            wheelSleep: 300,
            speed: 600,
            pagination: false,
            arrows: false,
            drag: true,
            snap: true,
            autoWidth: false,
            autoHeight: false
          });

          // Listen for slide changes
          this.splideInstance.on('moved', (newIndex) => {
            console.log('Slide moved to:', newIndex);
            
            // Pause all videos first
            this.pauseAllMobileVideos();
            
            // Update current video index
            this.currentMobileVideo = newIndex + 1;
            this.$store.ugc.currentVideo = this.currentMobileVideo;
            
            // Force autoplay the new video after a short delay to ensure DOM is ready
            setTimeout(() => {
              this.forcePlayMobileVideo(this.currentMobileVideo);
            }, 100);
          });

          this.splideInstance.mount();
          console.log('Splide mounted successfully');
        });
      },

      pauseAllMobileVideos() {
        const videoCount = document.querySelectorAll('[x-ref^="mobileVideo"]').length;
        for (let i = 1; i <= videoCount; i++) {
          const video = this.$refs['mobileVideo' + i];
          if (video) {
            video.pause();
            this.updateMobilePlayState(i, false);
          }
        }
      },

      playMobileVideo(videoIndex) {
        const video = this.$refs['mobileVideo' + videoIndex];
        if (video) {
          // Lazy load video if not already loaded
          this.lazyLoadVideo(video);
          
          video.muted = this.isMuted;
          video.play().catch(e => console.error('Error playing mobile video:', e));
        }
      },

      forcePlayMobileVideo(videoIndex) {
        const video = this.$refs['mobileVideo' + videoIndex];
        if (video) {
          console.log('Force playing mobile video:', videoIndex);
          
          // Lazy load video if not already loaded
          this.lazyLoadVideo(video);
          
          // Ensure video is ready and not in a blocked state
          video.muted = this.isMuted;
          
          // Reset video to beginning if needed (optional)
          // video.currentTime = 0;
          
          // Force play and update UI state
          video.play()
            .then(() => {
              console.log('Video', videoIndex, 'started playing successfully');
              this.updateMobilePlayState(videoIndex, true);
            })
            .catch(e => {
              console.error('Error force playing mobile video:', e);
              // Fallback: try muted autoplay
              video.muted = true;
              this.isMuted = true;
              this.updateVolumeButtonState();
              video.play().catch(err => console.error('Fallback play failed:', err));
            });
        }
      },

      updateVolumeButtonState() {
        const volumeOnBtn = this.$refs.mobileVolumeOnBtn;
        const volumeDownBtn = this.$refs.mobileVolumeDownBtn;
        
        if (this.isMuted) {
          if (volumeOnBtn) volumeOnBtn.style.display = 'none';
          if (volumeDownBtn) volumeDownBtn.style.display = 'block';
        } else {
          if (volumeOnBtn) volumeOnBtn.style.display = 'block';
          if (volumeDownBtn) volumeDownBtn.style.display = 'none';
        }
      },

      toggleMobilePlay(videoIndex) {
        const video = this.$refs['mobileVideo' + videoIndex];
        if (video) {
          if (video.paused) {
            // Lazy load video before playing
            this.lazyLoadVideo(video);
            video.play();
          } else {
            video.pause();
          }
        }
      },

      updateMobilePlayState(videoIndex, isPlaying) {
        const playBtn = this.$refs['mobilePlayBtn' + videoIndex];
        const pauseBtn = this.$refs['mobilePauseBtn' + videoIndex];
        
        if (isPlaying) {
          if (playBtn) playBtn.style.display = 'none';
          if (pauseBtn) pauseBtn.style.display = 'block';
        } else {
          if (playBtn) playBtn.style.display = 'block';
          if (pauseBtn) pauseBtn.style.display = 'none';
        }
      },

      toggleMobileVolume() {
        this.isMuted = !this.isMuted;
        
        // Update current video's mute state
        const currentVideo = this.$refs['mobileVideo' + this.currentMobileVideo];
        if (currentVideo) {
          currentVideo.muted = this.isMuted;
        }

        // Update volume button states
        const volumeOnBtn = this.$refs.mobileVolumeOnBtn;
        const volumeDownBtn = this.$refs.mobileVolumeDownBtn;
        
        if (this.isMuted) {
          if (volumeOnBtn) volumeOnBtn.style.display = 'none';
          if (volumeDownBtn) volumeDownBtn.style.display = 'block';
        } else {
          if (volumeOnBtn) volumeOnBtn.style.display = 'block';
          if (volumeDownBtn) volumeDownBtn.style.display = 'none';
        }
      },

      lazyLoadVideo(videoElement) {
        // Check if video is already loaded
        if (videoElement.dataset.lazyLoaded === 'true') {
          return;
        }

        console.log('Lazy loading mobile video sources...');
        
        // Find template elements with video sources
        const templates = videoElement.querySelectorAll('.video-source-template');
        
        templates.forEach(template => {
          const source = document.createElement('source');
          source.src = template.dataset.src;
          source.type = template.dataset.type;
          videoElement.appendChild(source);
        });

        // Mark as loaded and reload video to recognize new sources
        videoElement.dataset.lazyLoaded = 'true';
        videoElement.load();
        
        console.log('Mobile video sources loaded');
      },

      updateSelectedVariant(variantId) {
        // Update price display when variant is selected
        const option = document.querySelector(`option[value="${variantId}"]`);
        if (option) {
          const price = option.dataset.price;
          const comparePrice = option.dataset.comparePrice;
          
          // You can update price display here if needed
          console.log('Selected variant:', variantId, 'Price:', price);
        }
      },

      addToCartFromModal() {
        const variantSelect = this.$refs.variantSelect;
        let variantId = null;

        // Check if product has variants
        if (variantSelect) {
          variantId = variantSelect.value;
          if (!variantId) {
            alert('Please select a size');
            return;
          }
        } else {
          // Single variant product - get the default variant ID
          const productForm = document.querySelector('product-form');
          if (productForm) {
            const hiddenVariantInput = productForm.querySelector('input[name="id"]');
            if (hiddenVariantInput) {
              variantId = hiddenVariantInput.value;
            }
          }
        }

        if (!variantId) {
          console.error('No variant ID found');
          return;
        }

        // Add to cart
        const formData = new FormData();
        formData.append('items[0][id]', variantId);
        formData.append('items[0][quantity]', '1');

        // Update button state
        const addToCartBtn = this.$refs.addToCartBtn;
        const originalText = addToCartBtn.textContent;
        addToCartBtn.textContent = 'Adding...';
        addToCartBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Added to cart:', data);
          addToCartBtn.textContent = 'Added!';
          
          // Trigger cart update events
          document.dispatchEvent(new CustomEvent('cart:item-added', {
            detail: { variant_id: variantId, quantity: 1 }
          }));

          // Reset button after 2 seconds
          setTimeout(() => {
            addToCartBtn.textContent = originalText;
            addToCartBtn.disabled = false;
          }, 2000);
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          addToCartBtn.textContent = 'Error - Try Again';
          setTimeout(() => {
            addToCartBtn.textContent = originalText;
            addToCartBtn.disabled = false;
          }, 2000);
        });
      }
    }));
  })